module.exports = __webpack_public_path__ + "static/media/speech-text-reader.9a8ace96.png";